module.exports = __webpack_public_path__ + "static/media/Arialb.76a58b2a.ttf";